import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';

/**
 * Lets engineers exercise the Manage Access UI in a deployed environment
 * before the real Pilot document ACL endpoints exist. MSW/MockService
 * only runs locally — production and other deployed envs rely on this flag
 * instead. Toggle `FlagType.AclMockFallback` in LaunchDarkly; Pilot document
 * ACL requests that 404 then fall back to the shared in-memory mock store.
 * Clause Library access (single + bulk) is real-only against Clausewitz and
 * does not use this fallback. Leave the flag off everywhere else.
 */
export function isAccessControlMockFallbackEnabled(): boolean {
  return getFlag(FlagType.AclMockFallback);
}
